export default {
  select: {
    width: '100%',
  },
  icon: {
    right: 5,
  },
};
